// *https://www.registers.service.gov.uk/registers/country/use-the-api*
import React from "react";
import { Mui } from "@osu/react-ui";
import { isEmpty, isEqual } from "lodash";
import withDropdownOptions from "../../hocs/withDropdownOptions";
import withOptionsFilter from "../../hocs/withOptionsFilter";
import { debouncedOptions } from "../../../util/enums";

const Autocomplete = withDropdownOptions(withOptionsFilter(Mui.Autocomplete))

function AsyncDropdown(props = {}) {
  const { options, className, onChange, error, filterState, helperText, sectionState, dataField, ...rest } = props;
  const [open, setOpen] = React.useState(false)
  const isDebounced = debouncedOptions.includes(rest?.subtype);
  const defaulValue = (isDebounced ? null : ""); // debounced dropdowns have object values and require null to clear
  const onOptionChange = (event, newValue) => (onChange((newValue ?? defaulValue)));
  return (
    <Mui.FormControl variant="outlined" {...rest} className={className} error={!!error}>
      <Autocomplete
        sx={{ minWidth: 'inherit', minHeight: 'inherit' }}
        style={{ minWidth: 100 }}
        onChange={onOptionChange}
        open={open}
        name={rest?.id}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        isOptionEqualToValue={(option, value) => {
          if(isEmpty(value)) return true;
          return isEqual(option.value, value.value);
        }}
        renderOption={(props, option) => (
          <li {...props}>
            {option?.title || option?.selectedTitle || ""}
          </li>
        )}
        getOptionLabel={(option) => {
          return (option?.title || option?.selectedTitle || "");
        }}
        getOptionDisabled={undefined}
        options={options}
        groupBy={(option) => option.group}
        PaperComponent={(props) =>  <Mui.Paper {...props} elevation={8} />}
        error={!!error}
        sectionState={sectionState}
        filterState={filterState}
        onKeyDown={(e) => {
          if(e.key === "Enter") {
            e.preventDefault(); // prevent form submission
          }
        }}
        {...rest}
      />
      <Mui.FormHelperText>{error}</Mui.FormHelperText>
    </Mui.FormControl>
  );
}

export default AsyncDropdown